import React, {useMemo} from 'react';

type NamedChildren<TNames extends string> = {
  [name in TNames]: React.ReactNode | null;
};

const getComponentWithName = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  components: any[],
  name: string,
): React.ReactNode => {
  const comps = components.filter(
    c => c && c.type && c.type.displayName === name,
  );
  return comps.length > 0 ? comps[0] : null;
};

export const useNamedChildren = <TNames extends string>(
  children: React.ReactNode | null,
  names: TNames[],
): NamedChildren<TNames> => {
  // Get child components
  const components = useMemo(() => React.Children.toArray(children), [
    children,
  ]);

  return useMemo(() => {
    const _namedChildren = {} as NamedChildren<TNames>;

    names.forEach(n => {
      _namedChildren[n] = getComponentWithName(components, n);
    });

    return _namedChildren;
  }, [components, names]);
};
